import APIRequestState from './_util/api-request';

class LookupEmailState extends APIRequestState {
  get method() { return 'GET'; }
  get url() { return '/auth/lookupEmail'; }
}

export default LookupEmailState;



// WEBPACK FOOTER //
// ./spa/state/lookup-email.jsx